// src/firebase.js
import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyBHc0bM8FIeV14aAfH8mC_SIlQXefuBE8k',
  authDomain: 'vakra-orders-received.firebaseapp.com',
  projectId: 'vakra-orders-received',
  storageBucket: 'vakra-orders-received.firebasestorage.app',
  messagingSenderId: '56991820937',
  appId: '1:56991820937:web:4f470dab790d9eeecf6a58',
};

const VAPID_KEY =
  'BFAxG2lB2u-xqJL185SSyvdC7aZcf2M9sDniFAn4WZ0QrRHPtAuU8FtYkkc_CzPhwtXRsx7DqqZnX45DzWAQY88';

const app = initializeApp(firebaseConfig);

let messagingInstance = null;
let serviceWorkerRegistrationPromise = null;

const isBrowser = () =>
  typeof window !== 'undefined' &&
  typeof navigator !== 'undefined';

export const getNotificationPermissionState = () => {
  if (typeof Notification === 'undefined') return 'unsupported';
  return Notification.permission;
};

export const registerFirebaseMessagingServiceWorker = async () => {
  if (!isBrowser() || !('serviceWorker' in navigator)) {
    throw new Error('Service worker browser me supported nahi hai.');
  }

  if (!serviceWorkerRegistrationPromise) {
    serviceWorkerRegistrationPromise = navigator.serviceWorker.register(
      '/firebase-messaging-sw.js',
      { scope: '/' }
    );
  }

  return serviceWorkerRegistrationPromise;
};

const getMessagingInstance = async () => {
  if (!isBrowser()) {
    throw new Error('Firebase messaging browser me hi available hai.');
  }

  const supported = await isSupported();

  if (!supported) {
    throw new Error('Is browser me Firebase notifications supported nahi hain.');
  }

  if (!messagingInstance) {
    messagingInstance = getMessaging(app);
  }

  return messagingInstance;
};

/**
 * askPermission:
 * - true  => user button click ke baad browser popup open kar sakte hain
 * - false => page load par popup force nahi hoga; already-granted permission me token refresh hoga
 */
export const requestNotificationPermission = async ({
  askPermission = false,
} = {}) => {
  try {
    if (typeof Notification === 'undefined') {
      throw new Error('Notifications browser me supported nahi hain.');
    }

    let permission = Notification.permission;

    if (permission === 'default' && askPermission) {
      permission = await Notification.requestPermission();
    }

    if (permission !== 'granted') {
      return {
        success: false,
        token: null,
        permission,
        message:
          permission === 'denied'
            ? 'Notifications blocked hain. Chrome site settings me Allow karein.'
            : 'Enable Notifications button par click karke permission Allow karein.',
      };
    }

    const serviceWorkerRegistration =
      await registerFirebaseMessagingServiceWorker();

    const messaging = await getMessagingInstance();

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration,
    });

    if (!token) {
      return {
        success: false,
        token: null,
        permission,
        message: 'FCM token generate nahi hua. Browser refresh karke dobara try karein.',
      };
    }

    console.log('[FCM] Token generated:', token);

    return {
      success: true,
      token,
      permission,
      message: 'FCM token generated successfully.',
    };
  } catch (err) {
    console.error('[FCM] Token error:', err);

    return {
      success: false,
      token: null,
      permission: getNotificationPermissionState(),
      message: err?.message || 'FCM token generate nahi hua.',
    };
  }
};

export const listenForForegroundMessages = async (callback) => {
  try {
    const messaging = await getMessagingInstance();

    return onMessage(messaging, (payload) => {
      console.log('[FCM] Foreground message:', payload);

      if (typeof callback === 'function') {
        callback(payload);
      }
    });
  } catch (err) {
    console.warn('[FCM] Foreground listener skipped:', err?.message || err);
    return () => {};
  }
};
